module.exports = __webpack_public_path__ + "img/HN.1135f601.svg";